/**
 * @file    BreadCrumb.css
 * @author  Kevin Yu <kevin@distributive.network>
 * @date    June 2024
 */

.bread-crumb {
  display: flex;
  gap: 10px;
  margin-bottom: 32px;
  
  /* Used to leave space for focus-visible ring */
  margin-top: 4px;
  margin-left: 4px;
}

.bread-crumb a {
  color: var(--content-hue-main);
  text-decoration: none;
  font-weight: 600;
}

.bread-crumb a:last-of-type {
  cursor: default;
}

.bread-crumb a:last-of-type:hover {
  filter: brightness(1);
}

.bread-crumb span {
  font-weight: bolder;
}

.bread-crumb a + span:last-of-type {
  display: none;
}
